export const buildFiltersParams = (
  filters: Record<string, any>,
): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => {
        if (v !== '') {
          params.append(`filters[${key}][]`, v);
        }
      });
    } else if (value !== '' && value !== undefined && value !== null) {
      params.append(`filters[${key}]`, value);
    }
  });

  return params;
};
